<!-- Template for the Toolbar Header -->
<ng-template #header let-terminal> </ng-template>

@if (iframeParams$ | async; as iframeParams) {
  <div class="layout-col full">
    <ng-container>
      <!-- In Kiosk-Mode, we replace the primary Header Toolbar -->
      <ng-container
        *elderShellSlot="'header'"
        [ngTemplateOutlet]="header"
        [ngTemplateOutletContext]="{ $implicit: iframeParams }"
      ></ng-container>
      <!-- disable static navigation -->
      <ng-template elderShellSlot="static-nav"></ng-template>
    </ng-container>
    <elder-i-frame-host class="flex" [iframeParams]="iframeParams"> </elder-i-frame-host>
  </div>
}
